import { Component, OnInit } from '@angular/core';
import { IBreadcrumbData } from '../../../../interfaces/breadcrumb-data.interface';

@Component({
  selector: 'app-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss'],
})
export class ListComponent implements OnInit {
  /**
   * BreadcrumbData
   */
  breadcrumbData: IBreadcrumbData;

  constructor() {
    this.breadcrumbData = {
      titles: {
        icon: 'rv_hookup',
        links: [
          {
            text: 'Lane control',
          },
        ],
      },
      description: 'Aquí puede ver el control de carril',
      buttons: [],
    };
  }

  ngOnInit(): void {}
}
